export const GET_PRINTER_SETTINGS_STARTED = "GET_PRINTER_SETTINGS_STARTED"
export const GET_PRINTER_SETTINGS_SUCCESS = "GET_PRINTER_SETTINGS_SUCCESS"
export const GET_PRINTER_SETTINGS_FAILURE = "GET_PRINTER_SETTINGS_FAILURE"

export const UPDATE_PRINTER_SETTINGS_STARTED = "UPDATE_PRINTER_SETTINGS_STARTED"
export const UPDATE_PRINTER_SETTINGS_SUCCESS = "UPDATE_PRINTER_SETTINGS_SUCCESS"
export const UPDATE_PRINTER_SETTINGS_FAILURE = "UPDATE_PRINTER_SETTINGS_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"